/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Enum for fields that can be used for sorting
 */
export enum ColumnOrderField {
  ID = "ID",
  LUID = "LUID",
  NAME = "NAME",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum DashboardOrderField {
  DOCUMENT_VIEW_ID = "DOCUMENT_VIEW_ID",
  ID = "ID",
  LUID = "LUID",
  NAME = "NAME",
  PATH = "PATH",
}

/**
 * Possible data types for a field.
 */
export enum FieldDataType {
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  DATETIME = "DATETIME",
  INTEGER = "INTEGER",
  REAL = "REAL",
  SPATIAL = "SPATIAL",
  STRING = "STRING",
  TABLE = "TABLE",
  TUPLE = "TUPLE",
  UNKNOWN = "UNKNOWN",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum FieldOrderField {
  ID = "ID",
  IS_HIDDEN = "IS_HIDDEN",
  NAME = "NAME",
}

/**
 * Possible roles of a field.
 */
export enum FieldRole {
  DIMENSION = "DIMENSION",
  MEASURE = "MEASURE",
  UNKNOWN = "UNKNOWN",
}

/**
 * Possible categories of a field role.
 */
export enum FieldRoleCategory {
  NOMINAL = "NOMINAL",
  ORDINAL = "ORDINAL",
  QUANTITATIVE = "QUANTITATIVE",
  UNKNOWN = "UNKNOWN",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum FlowOrderField {
  CONTAINER_NAME = "CONTAINER_NAME",
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = "CONTAINS_UNSUPPORTED_CUSTOM_SQL",
  HAS_ACTIVE_WARNING = "HAS_ACTIVE_WARNING",
  ID = "ID",
  LUID = "LUID",
  NAME = "NAME",
  PROJECT_NAME = "PROJECT_NAME",
  VIZPORTAL_URL_ID = "VIZPORTAL_URL_ID",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum FlowOutputFieldOrderField {
  ID = "ID",
  NAME = "NAME",
}

/**
 * General object for sorting
 */
export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum PublishedDatasourceOrderField {
  CONTAINER_NAME = "CONTAINER_NAME",
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = "CONTAINS_UNSUPPORTED_CUSTOM_SQL",
  DOWNSTREAM_OWNERS_COUNT = "DOWNSTREAM_OWNERS_COUNT",
  DOWNSTREAM_SHEETS_COUNT = "DOWNSTREAM_SHEETS_COUNT",
  DOWNSTREAM_WORKBOOKS_COUNT = "DOWNSTREAM_WORKBOOKS_COUNT",
  FIELDS_COUNT = "FIELDS_COUNT",
  HAS_ACTIVE_WARNING = "HAS_ACTIVE_WARNING",
  ID = "ID",
  IS_CERTIFIED = "IS_CERTIFIED",
  LUID = "LUID",
  NAME = "NAME",
  OWNER_COUNT = "OWNER_COUNT",
  PROJECT_NAME = "PROJECT_NAME",
  VIZPORTAL_URL_ID = "VIZPORTAL_URL_ID",
}

/**
 * Possible types of remote types
 * 
 * Types correspond to OLEDB types here: https: // referencesource.microsoft.com/#system.data/System/Data/OleDb/OLEDB_Enum.cs,364"
 * 
 * Types prefixed with 'WDC' correspond to Tableau's Web Data Connector types:
 * https:                                       // tableau.github.io/webdataconnector/docs/api_ref.html#webdataconnectorapi.datatypeenum
 */
export enum RemoteType {
  ARRAY = "ARRAY",
  BOOL = "BOOL",
  BSTR = "BSTR",
  BYREF = "BYREF",
  BYTES = "BYTES",
  CY = "CY",
  DATE = "DATE",
  DBDATE = "DBDATE",
  DBTIME = "DBTIME",
  DBTIMESTAMP = "DBTIMESTAMP",
  DECIMAL = "DECIMAL",
  EMPTY = "EMPTY",
  ERROR = "ERROR",
  FILETIME = "FILETIME",
  GUID = "GUID",
  HCHAPTER = "HCHAPTER",
  I1 = "I1",
  I2 = "I2",
  I4 = "I4",
  I8 = "I8",
  IDISPATCH = "IDISPATCH",
  IUNKNOWN = "IUNKNOWN",
  NULL = "NULL",
  NUMERIC = "NUMERIC",
  PROPVARIANT = "PROPVARIANT",
  R4 = "R4",
  R8 = "R8",
  RESERVED = "RESERVED",
  STR = "STR",
  UDT = "UDT",
  UI1 = "UI1",
  UI2 = "UI2",
  UI4 = "UI4",
  UI8 = "UI8",
  VARIANT = "VARIANT",
  VARNUMERIC = "VARNUMERIC",
  VECTOR = "VECTOR",
  WDC_BOOL = "WDC_BOOL",
  WDC_DATE = "WDC_DATE",
  WDC_DATETIME = "WDC_DATETIME",
  WDC_FLOAT = "WDC_FLOAT",
  WDC_GEOMETRY = "WDC_GEOMETRY",
  WDC_INT = "WDC_INT",
  WDC_STRING = "WDC_STRING",
  WSTR = "WSTR",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum SheetOrderField {
  DATASOURCE_FIELDS_COUNT = "DATASOURCE_FIELDS_COUNT",
  DOCUMENT_VIEW_ID = "DOCUMENT_VIEW_ID",
  ID = "ID",
  LUID = "LUID",
  NAME = "NAME",
  PATH = "PATH",
  SHEET_FIELD_INSTANCES_COUNT = "SHEET_FIELD_INSTANCES_COUNT",
  WORKSHEET_FIELDS_COUNT = "WORKSHEET_FIELDS_COUNT",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum TableauUserOrderField {
  DOMAIN = "DOMAIN",
  EMAIL = "EMAIL",
  ID = "ID",
  LUID = "LUID",
  NAME = "NAME",
  USERNAME = "USERNAME",
}

/**
 * Enum for fields that can be used for sorting
 */
export enum WorkbookOrderField {
  CONTAINER_NAME = "CONTAINER_NAME",
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = "CONTAINS_UNSUPPORTED_CUSTOM_SQL",
  DASHBOARDS_COUNT = "DASHBOARDS_COUNT",
  EMBEDDED_DATASOURCES_COUNT = "EMBEDDED_DATASOURCES_COUNT",
  ID = "ID",
  LUID = "LUID",
  NAME = "NAME",
  OWNER_COUNT = "OWNER_COUNT",
  PROJECT_NAME = "PROJECT_NAME",
  SHEETS_COUNT = "SHEETS_COUNT",
  VIEWS_COUNT = "VIEWS_COUNT",
  VIZPORTAL_URL_ID = "VIZPORTAL_URL_ID",
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface ColumnSortOrder {
  field: ColumnOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface DashboardSortOrder {
  field: DashboardOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface FieldSortOrder {
  field: FieldOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface FlowOutputFieldSortOrder {
  field: FlowOutputFieldOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface FlowSortOrder {
  field: FlowOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface PublishedDatasourceSortOrder {
  field: PublishedDatasourceOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface SheetSortOrder {
  field: SheetOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface TableauUserSortOrder {
  field: TableauUserOrderField;
  direction: OrderDirection;
}

/**
 * Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order.
 */
export interface WorkbookSortOrder {
  field: WorkbookOrderField;
  direction: OrderDirection;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
